import { useEffect, useState } from "react";
import contact from "../../../../../assets/images/contact.svg";
import card1 from "../../../../../assets/images/card1.svg";
import card2 from "../../../../../assets/images/card2.svg";
import styles from "./AdminPriceUpdate.module.scss";
import { routeConfig } from "../../../../../common/constants/routeConfig";
import { useNavigate } from "react-router-dom";
import { ToastNotification } from "../../../../../common/components/toastNotification/ToastNotification";
import errorToast from "../../../../../assets/images/errorToast.svg";
import successToast from "../../../../../assets/images/successToast.svg";
import { constants } from "../../../../../common/constants/constants";
import CategoryCard from "../../../../../common/components/categoryCard/CategoryCard";
import { useDispatch } from "react-redux";
import { updateIsLoading } from "../../../../../reducerSlices/loaderSlice";
import { urlConstants } from "../../../../../common/constants/urlConstants";

function AdminPriceUpdate() {
  const navigate = useNavigate();
  const [, setIsAdmin] = useState(false);
  const [toastData, setToastData] = useState(constants.defaultToastData);
  const [worker, setWorker] = useState<Worker | null>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    // Create the worker
    const newWorker = new Worker(
      new URL("../../../../../workers/priceUpdateWorker", import.meta.url),
    );
    setWorker(newWorker);

    // Cleanup
    return () => {
      newWorker.terminate();
    };
  }, []);

  useEffect(() => {
    const userData = localStorage.getItem("loggedInUser");
    if (userData != null) {
      const loggedInUser = JSON.parse(userData);
      if (loggedInUser?.typeOfUser.includes("admin")) {
        setIsAdmin(true);
      } else {
        setIsAdmin(false);
      }
    } else {
      setIsAdmin(false);
    }
  }, []);

  const handleEditFileUpload = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    if (!worker) return;
    const input = event.target;

    const allowedExtensions = ["xlsx", "xls", "csv"];

    if (input?.files && input?.files[0]) {
      const uploadedFile = input.files[0];
      const fileExtension = uploadedFile.name.split(".").pop()?.toLowerCase();
      if (allowedExtensions?.includes(fileExtension as string)) {
        try {
          dispatch(updateIsLoading(true));
          worker.postMessage({ uploadedFile });

          // Listen for messages from the worker
          const result = await new Promise<any>((resolve, reject) => {
            worker.onmessage = (event) => {
              const {
                parsedRows,
                filteredData,
                totalOriginalRows,
                totalFilteredRows,
                error,
              } = event.data;

              if (error) {
                reject(error);
              } else {
                resolve({
                  parsedRows,
                  filteredData,
                  totalOriginalRows,
                  totalFilteredRows,
                });
              }
            };
          });

          if (result.totalFilteredRows < 1) {
            setToastData({
              message: `No data meets the upload criteria. Please check your file.`,
              status: "Fail",
            });
            setTimeout(() => {
              setToastData(constants.defaultToastData);
            }, 6000);
          } else {
            const updatePrice = await fetch(
              `${urlConstants.BASE_URL}admin/product/bulk_price_update`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  authorization: `Bearer ${localStorage.getItem("token")}`,
                },
                body: JSON.stringify({
                  price_update_data: result.filteredData,
                }),
              },
            );

            if (updatePrice.ok) {
              const priceUpdateData: {
                data: {
                  price_update_res: {
                    status: string;
                    updated_variants: number;
                    updated_products: number;
                    skipped_variants: number;
                  };
                  deactivate_res: {
                    status: string;
                    deactivated_products: number;
                    skipped_products: number;
                  };
                  activate_product_res: {
                    status: string;
                    activated_products: number;
                    skipped_products: number;
                  };
                };
              } = await updatePrice.json();
              setToastData({
                message: `Price update ${priceUpdateData.data.price_update_res.status}. 
                Updated: ${priceUpdateData.data.price_update_res.updated_variants}, 
                Activated : ${priceUpdateData.data.activate_product_res.activated_products},
                Deactivated : ${priceUpdateData.data.deactivate_res.deactivated_products}.`,
                status: "Success",
              });
              setTimeout(() => {
                setToastData(constants.defaultToastData);
              }, 12000);
            }

            dispatch(updateIsLoading(false));
          }
        } catch (error: any) {
          console.log(error);
          if (error?.message?.includes('Sheet "Products list" not found')) {
            setToastData({
              message: `Sheet name is not matching, provide a valid sheet with "Products list" as name`,
              status: "Fail",
            });
            setTimeout(() => {
              setToastData(constants.defaultToastData);
            }, 3000);
          } else {
            setToastData({ message: `Invalid Excel Template`, status: "Fail" });
            setTimeout(() => {
              setToastData(constants.defaultToastData);
            }, 3000);
          }
        } finally {
          dispatch(updateIsLoading(false));
        }
      } else {
        setToastData({
          message: `Please upload a valid Excel file.`,
          status: "Fail",
        });
        setTimeout(() => {
          setToastData(constants.defaultToastData);
        }, 3000);
      }
    }
  };

  return (
    <div className={styles.app}>
      <div className={styles.rightBodyContainer}>
        <div className={styles.text}>
          {constants.manageCatalogue.modifyBulkProduct}
        </div>
        <div className={styles.outerBox}>
          <div className={styles.outerBox1}>
            <div className={styles.card1}>
              <CategoryCard
                cardType="search"
                imgSrc={card1}
                head="Download Template"
                id={1}
                title={<div>{}</div>}
                handleCardClick={() => {
                  navigate(routeConfig.adminGeneratePriceUpdateSheet);
                }}
                isModify={true}
              />
            </div>
            <div className={styles.card2}>
              <div>
                <label htmlFor="adminPriceUpdate">
                  <input
                    className={styles.inputField}
                    type="file"
                    id="adminPriceUpdate"
                    onChange={handleEditFileUpload}
                    accept=".xls, .xlsx"
                    onClick={(event: any) => {
                      event.target.value = null;
                    }}
                  />
                  <CategoryCard
                    cardType="search"
                    imgSrc={card2}
                    head="Bulk Price Update"
                    id={4}
                    title={<></>}
                    handleCardClick={() => {}}
                  />
                </label>
              </div>
            </div>
          </div>
          <div className={styles.contact}>
            <div className={styles.logo}>
              <img className={styles.imgLogo} src={contact} alt="Contact" />
            </div>
            <div className={styles.contactText}>
              <p className={styles.contactText1}>
                {constants.manageCatalogue.help}
              </p>
              <p className={styles.contactText2}>
                {constants.manageCatalogue.email} |
                {constants.manageCatalogue.phoneNo}
              </p>
            </div>
          </div>
        </div>
      </div>
      {toastData?.message && (
        <ToastNotification
          icon={toastData.status === "Success" ? successToast : errorToast}
          content={toastData?.message}
          position={"top-right"}
          autoClose={10000}
        />
      )}
    </div>
  );
}

export default AdminPriceUpdate;
